import React, { ReactNode } from 'react';

type SubheaderProps = {
  className?: string;
  children?: ReactNode | string;
};
export default function Subheader(props: SubheaderProps) {
  return <h2 className={`mb-8 font-bold ${props.className}`}>{props.children}</h2>;
}
